export interface FinancialData {
  loan_application_id: number;
  external_loan_number: string;
  prepaid_interest: number;
  secondary_market_accrued_interest: number;
  sales_adjustments_and_or_penalties: number;
  interest_income: number;
  origination_proceeds: number;
  other_revenue: number;
  curtailments: number;
  additional_fees: number;
  hedging_gains: number;
}

/** For taking FinancialData emitted by the API and parsing number values from strings. */
export const parseFinancialDataResponse = (obj: any): FinancialData => {
  const {
    prepaid_interest,
    secondary_market_accrued_interest,
    sales_adjustments_and_or_penalties,
    interest_income,
    origination_proceeds,
    other_revenue,
    curtailments,
    additional_fees,
    hedging_gains,
  } = obj;

  return {
    ...obj,
    prepaid_interest: Number(prepaid_interest),
    secondary_market_accrued_interest: Number(secondary_market_accrued_interest),
    sales_adjustments_and_or_penalties: Number(sales_adjustments_and_or_penalties),
    interest_income: Number(interest_income),
    origination_proceeds: Number(origination_proceeds),
    other_revenue: Number(other_revenue),
    curtailments: Number(curtailments),
    additional_fees: Number(additional_fees),
    hedging_gains: Number(hedging_gains),
  };
};
